import { render, staticRenderFns } from "./BasePickupDeliveryForm.vue?vue&type=template&id=19c98ca0&scoped=true"
import script from "./BasePickupDeliveryForm.vue?vue&type=script&lang=js"
export * from "./BasePickupDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./BasePickupDeliveryForm.vue?vue&type=style&index=0&id=19c98ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c98ca0",
  null
  
)

export default component.exports